export * from './badge.component.js';
